export const GET_HIGHLIGHTS_DETAILS_SUCCESS = 'HIGHLIGHTS/GET_HIGHLIGHTS_DETAILS_SUCCESS';
export const GET_HIGHLIGHTS_DETAILS_ERROR = 'HIGHLIGHTS/GET_HIGHLIGHTS_DETAILS_ERROR';
export const CLEAR_GET_HIGHLIGHTS_DETAILS = 'HIGHLIGHTS/CLEAR_GET_HIGHLIGHTS_DETAILS';

export const ADD_HIGHLIGHTS_DETAIL_SUCCESS = 'HIGHLIGHTS/ADD_HIGHLIGHTS_DETAIL_SUCCESS';
export const ADD_HIGHLIGHTS_DETAIL_ERROR = 'HIGHLIGHTS/ADD_HIGHLIGHTS_DETAIL_ERROR';
export const CLEAR_ADD_HIGHLIGHTS_DETAIL = 'HIGHLIGHTS/CLEAR_ADD_HIGHLIGHTS_DETAIL';

export const PATCH_HIGHLIGHTS_DETAIL_SUCCESS = 'HIGHLIGHTS/PATCH_HIGHLIGHTS_DETAIL_SUCCESS';
export const PATCH_HIGHLIGHTS_DETAIL_ERROR = 'HIGHLIGHTS/PATCH_HIGHLIGHTS_DETAIL_ERROR';
export const CLEAR_PATCH_HIGHLIGHTS_DETAIL = 'HIGHLIGHTS/CLEAR_PATCH_HIGHLIGHTS_DETAIL';

export const DELETE_HIGHLIGHTS_DETAIL_SUCCESS = 'HIGHLIGHTS/DELETE_HIGHLIGHTS_DETAIL_SUCCESS';
export const DELETE_HIGHLIGHTS_DETAIL_ERROR = 'HIGHLIGHTS/DELETE_HIGHLIGHTS_DETAIL_ERROR';
export const DELETE_PATCH_HIGHLIGHTS_DETAIL = 'HIGHLIGHTS/CLEAR_DELETE_HIGHLIGHTS_DETAIL';
